'use client'
import { AchieveLink } from 'components/AchieveLink'
import styles from './Pills.module.scss'
import { useAppRouter } from 'hooks/useAppRouter/useAppRouter'
import classNames from 'classnames'
import { getSlug } from 'utils/conversions'
import { mainProductConfig } from 'constants/mainProductConfig'

function Pill({ category, article, pathOverride, path, id, className = '' }) {
  const { dynamicPathname } = useAppRouter()
  const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT || 'achieve'
  const urlMaker = (str) => {
    const getPath = () => {
      let fullPath = dynamicPathname
      return fullPath.split('[')?.[0]
    }
    const url = article ? pathOverride : getPath()
    return `${url}${getSlug(str)}`
  }

  const makePill = (category) => {
    return (
      <AchieveLink
        href={`${path ?? urlMaker(category)}`}
        underline="none"
        data-testid="pill"
        className={classNames(
          'inline-flex items-center justify-center gap-2 rounded-full px-2 min-h-[32px] text-sm no-underline transition-colors bg-blue-50 text-blue-600 hover:bg-blue-100 hover:no-underline',
          styles['pill'],
          className
        )}
        track={{
          list_name: 'Categories',
          click_id: category,
          click_position: id,
          click_text: `${
            mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
          } | ${category}`,
          click_type: 'Link Click',
          nav_link_section: 'Categories',
          track_event: 'page_nav_click',
          event_action: 'link_click',
          event_type: 'link_click',
        }}
      >
        {category}
      </AchieveLink>
    )
  }

  return makePill(category)
}

export { Pill }
